import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { HomepageSeo } from '../components/Seo/homepage-seo'
import { type HomepageSeoProps } from '../types/homepageSeo'

export const mount: MountWithRootOptions<HomepageSeoProps> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<HomepageSeo {...renderProps} />, rootElement, rootOptions)
}
